import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class BecasService
{
    constructor(public http: HttpClient, ) { }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    obtieneProductos() 
    { 
        return this.http.get(`${environment.urlBase}/productos`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }
    ingresaBeca(beca: any, idUsuario:any, idCarga:any, nombreUsuario: any,idUsuarioSesion:any)
    {
        console.log(beca, idUsuario, idCarga,idUsuarioSesion)
        return this.http.post(`${environment.urlBase}/postulaciones/becas`,
        {
            idUsuario: idUsuario,
            idUsuarioSesion:idUsuarioSesion,
            idCarga:idCarga,
            idProducto: 1,
            email: beca.email,
            beca: { idTipoBeca:beca.tipoBeca, calificacion: beca.nota, idCurso: beca.curso, diagnosticoEspecial: beca.diagnostico },
              archivoAdjunto: beca.archivo,
            //archivoAdjunto: [ { url: "nada" } ],
            notificacion: { email:beca.email, nombreCompleto:nombreUsuario, nombreProducto:'BECA' }

        }, { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
